<div class="h-full flex flex-col" [class]="direction">
  <app-detailed-result-buttons [buttons]="resultButtons" />

  <div class="px-4 flex-1 overflow-hidden min-h-0 relative">
    @if (!!stop.photos && stop.photos.length > 0) {
      <h3 class="text-lg">{{stationPicturesText}}</h3>
      <div class="flex gap-2 flex-wrap">
        @for (photoUrl of stop.photos; track photoUrl; let i = $index) {
          <!--
            a11y: clickable thumbnail wrapped in a real <button> so it's keyboard
            reachable + announced as a button. aria-haspopup="dialog" tells SR
            users the activation opens a fullscreen carousel. The <img> alt
            describes the image content for users who view the rendered button.
          -->
          <button
            type="button"
            class="p-0 border-0 bg-transparent cursor-pointer rounded-xl"
            aria-haspopup="dialog"
            [attr.aria-label]="stationPhotoButtonAriaLabel(i)"
            (click)="openStationImagesCarousel(i)">
            <img
              class="rounded-xl h-24 w-24"
              [src]="photoUrl"
              [alt]="stationPhotoAlt(i)" />
          </button>
        }
      </div>
    }

    @if (!!stop.routesInStop && stop.routesInStop.length > 0) {
      <h3 class="text-lg">{{linesInStationText}}</h3>
      <div class="py-4 box-border h-full" >
        <div class="flex flex-col gap-3 overflow-y-auto use-scrollbar px-1" style="max-height: calc(100% - 100px);">
          @for (line of stop.routesInStop; track line) {
            <div class="flex justify-between items-center">
              <div class="flex gap-2 items-center" [ngClass]="{'flex-col !items-start': isMobile()}">
                <app-line-details [line]="line" [tripHeadSign]="getTripHeadSign(line)"/>
                @if (line.platformNumber && !isOnlyPickUp(line.routeId)) {
                  <!-- contrast: #959799 (~3:1) failed AA; subText (#5C748F, ~4.9:1) passes. -->
                  <span class="text-subText text-xs" [ngClass]="{'!px-2': isMobile()}">{{platformText}} {{line.platformNumber}}</span>
                }
                @if (isOnlyPickUp(line.routeId)) {
                  <span class="text-red-500 text-xs" [ngClass]="{'!px-2': isMobile()}">
                    {{onlyDropOffText}}
                  </span>
                }
                @if (isOnlyDropOff(line.routeId)) {
                  <span class="text-red-500 text-xs" [ngClass]="{'!px-2': isMobile()}">{{pickUpOnlyText}}</span>
                }
                @if (isNoPickupOrDropOff(line.routeId)) {
                  <span class="text-red-500 text-xs" [ngClass]="{'!px-2': isMobile()}">{{noPickupOrDropOffText}}</span>
                }
              </div>
              @if (line.specialMessages?.length) {
                <mot-button [icon]="'message-exclamation'"
                  [text]="getLineSpecialMessagesCount(line) + ' ' + specialMessagesText"
                  buttonClass="!bg-[#D4282E] !rounded-lg !text-white !pr-1 !pl-[0.375rem] !h-[1.5rem]"
                  textClass="!text-sm !font-normal" ariaHaspopup="dialog"
                  (onClick)="openSpecialMessages(line.specialMessages); $event.stopPropagation()" />
              }
            </div>
            <mat-divider />
          }
        </div>
      </div>
    }
    <div class="sticky bottom-[1%] left-0 right-0 flex justify-between items-center bg-gray-200 rounded-xl p-2 z-50">
      <app-rating [rating]="stop.rating" />
      <mot-button [matTooltip]="alreadyRatedText" matTooltipPosition="above" [matTooltipDisabled]="!isRatedStop"
        [disabled]="!!isRatedStop" [text]="rateText" (onClick)="openStationRatingPopUp(stop.rating)" ariaHaspopup="dialog"
        buttonClass="!h-6 !bg-transparent" />
      </div>
    </div>
  </div>